<template>
  <div>
    <div
      class="banner"
      v-if="bannerImg!=''"
    >
      <img :src="bannerImg" />
    </div>
    <div
      class="zhuantiArea"
      v-if="zhuantiChildrens.length>0"
    >
      <ul class="unitList">
        <li
          v-for="(course,index1) in zhuantiChildrens"
          :key="index1"
        >
          <div>
            <h1
              v-if="course.childrens.length>0"
              v-html="course.name"
            ></h1>
            <h1
              v-else
              class="colorGray"
              @click="lockTips"
              v-html="course.name"
            ></h1>
            <ul v-if="course.childrens.length>0 && course.childrens[0].name!=undefined">
              <li
                v-for="(lession,index2) in course.childrens"
                :key="index2"
              >
                <div v-if="lession.childrens.length>0">
                  <span v-text="lession.name"></span>
                </div>
                <div
                  v-else
                  class="colorGray"
                  @click="lockTips"
                >
                  <span v-text="lession.name"></span>
                </div>
                <ul v-if="lession.childrens.length>0">
                  <li
                    v-for="(book,index3) in lession.childrens"
                    :key="index3"
                    @click="goPlayVideo(book.videoCode,book.contentPos,course.name)"
                  >
                    <i class="icoPlay"></i>
                    <span v-text="book.showName"></span>
                  </li>
                </ul>
              </li>
            </ul>
            <ul v-if="course.childrens.length>0 && course.childrens[0].name==undefined">
              <li>
                <ul>
                  <li
                    v-for="(book,index3) in course.childrens"
                    :key="index3"
                    @click="goPlayVideo(book.videoCode,book.contentPos,course.name)"
                  >
                    <i class="icoPlay"></i>
                    <span v-text="book.showName"></span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
    <div
      class="zhuantiArea2"
      v-if="fangyiChildrens.length>0"
    >
      <ul
        class="unitList"
        v-for="(unit,index) in fangyiChildrens"
        :key="index"
      >
        <h1 v-html="unit.name"></h1>
        <li
          v-for="(book,index3) in unit.childrens"
          :key="index3"
          @click="goPlayVideo(book.videoCode,book.contentPos,unit.name)"
        >
          <i class="icoPlay"></i>
          <span v-text="book.showName"></span>
        </li>
      </ul>
    </div>
      <askMore :show="showAskMore" @close="showAskMore = false"></askMore>
  </div>
</template>

<script>
import paramsHelper from '@/assets/js/parametersHelper'
import askMore from "@/components/common/askMore";
import { baseUrl } from '@/assets/js/api'
export default {
    name: 'SpecialContent',
    components: { askMore },
    data () {
        return {
            contentHost: '',
            msg: '网络数据请求异常',
            bannerImg: '',
            zhuantiChildrens: [],
            fangyiChildrens: [],
            showAskMore: false,
        }
    },
    created: function () {
        var that = this;
        var host = that.contentHost = sessionStorage.c_host;
        let { id, name, gradeId, index,df } = paramsHelper.decode(this.$route.query.params);
        if (index === undefined) {
            that.getZhuantiContent(id, name, gradeId);
        } else {
            var zhuantiChildrens = JSON.parse(sessionStorage.c_subZhuantiList);
            that.zhuantiChildrens = zhuantiChildrens[parseInt(index)].childrens;
            if (zhuantiChildrens.length > 0 && name == 'zhuanti') {
                that.bannerImg = host + zhuantiChildrens[parseInt(index)].coverImage;
            }
            this.jumpScrollTop();
        }
    },
    mounted: function () {
        var that = this;
        // if (sessionStorage.c_currPlayData != undefined) {
        //     that.postPlayData(sessionStorage.c_currPlayData);
        // }
    },
    destroyed: function () {

    },
    beforeRouteLeave(to, from, next) {
        if(to.path === '/Video') {
            sessionStorage.setItem('special-scroll-top', (document.documentElement.scrollTop || document.body.scrollTop));
        }
        next();
    },
    methods: {
        jumpScrollTop() {
            let top = sessionStorage.getItem('special-scroll-top');
            if(top) {
                document.documentElement.scrollTop = Number(top);
                document.body.scrollTop = Number(top);
                sessionStorage.removeItem('special-scroll-top')
            }
        },
        jumpTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },
        getZhuantiContent: function (id, name, gradeId) {
            var that = this;
            var axurl = baseUrl + '/ures/resource/prelearn/getZhuantiContent';
            if (name == 'fangyi') {
                axurl = baseUrl + '/ures/resource/prelearn/getFangyiContent';
            }
            this.$axios.get(axurl, {
                params: {
                    gradeId,
                    id
                }
            }).then(res => {
                let { status, msg, value } = res && res.data
                if (status == 1) {
                    let { host, contents, childrens } = value
                    that.contentHost = host;
                    if (name == 'zhuanti') {
                        if (childrens.length > 1) {
                            sessionStorage.c_subZhuantiList = JSON.stringify(childrens);
                            that.$router.replace({
                                name: 'SpecialContentList',
                                query: { params: paramsHelper.encode({ id, name, gradeId }),lessonId:that.$route.query.lessonId }
                            })
                        } else if (childrens.length == 1) {
                            that.zhuantiChildrens = childrens[0].childrens;
                        } else { }
                    } else {
                        that.fangyiChildrens = childrens;
                    }
                    sessionStorage.c_contentContents = JSON.stringify(contents);
                    if (childrens.length > 0 && name == 'zhuanti') {
                        that.bannerImg = host + childrens[0].coverImage;
                    }
                } else {
                    sessionStorage.removeItem('c_contentContents');
                    //vant.Toast(msg);
                }
            }).catch(function (err) {
                that.$toast(err.errmsg || err.data.errmsg);
            }).finally(() => {
                this.$nextTick(() => {
                    this.jumpScrollTop();
                })
            });

        },
        lockTips: function () {
            /*this.$Dialog.alert({
                confirmButtonText: '知道了',
                message: '进一步了解详情<br>请咨询教育顾问'
            }).then(() => {
                // on close
            });*/
            this.showAskMore = true;
        },
        goPlayVideo: function (videoId, pos, courseName) {
          if(!videoId){
            this.$toast('视频暂未开放,请联系工作人员。');
            return false
          } else {
            this.$router.push({
                name: 'Video',
                query: { params: paramsHelper.encode({ videoId, videoType: undefined, pos, courseName }),lessonId:this.$route.query.lessonId }
            })
          }
        },
        postPlayData: function (jsonArray) {
            var that = this;
            // axios.get(baseUrl + '/ures/resource/prelearn/saveVideoTime', {
            //     params: {
            //         jsonArray: jsonArray
            //     }
            // }).then(function (res) {
            //     var status = res.data.status;
            //     var msg = res.data.msg;
            //     if (msg == 'success') {
            //         sessionStorage.removeItem('c_currPlayData');
            //     }
            // }).catch(function (err) {
            //     //vant.Toast(that.msg);
            // });
        }
    }
}
</script>

<style scope lang="less">
</style>
